<div class="btn-container">
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="changeSupplierAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Schimba furnizor</p>
    </button>
  </div>

  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="sendIndexAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Trimitere index</p>
    </button>
  </div>
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="quitMenuAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Renunta</p>
    </button>
  </div>

  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="quitMenuAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Inceteaza</p>
    </button>
  </div>
</div>
